import React, { FunctionComponent } from 'react';
import Styles from '../PublicProfile.module.scss';

export type CardBreakdownItem = {
  label: string;
  value: string;
};

interface CardItemProps {
  title: string;
  description: string;
  cssClass?: string;
  total: string;
  /** Inline next to the title, e.g. Chat: 0.00hrs | Video: 0.00hrs */
  breakdown?: CardBreakdownItem[];
}

const CardItem: FunctionComponent<CardItemProps> = (props: CardItemProps) => {
  const { title, description, total, cssClass, breakdown } = props;

  return (
    <div className={`${Styles.cardInner} ${cssClass || ''}`}>
      <div className={Styles.cardTitleRow}>
        <h5 className={Styles.cardTitle}>{title}</h5>
        {breakdown && breakdown.length > 0 ? (
          <p className={Styles.cardBreakdownInline}>
            {breakdown.map((item, index) => (
              <span key={item.label}>
                {index > 0 ? ' | ' : null}
                {item.label}: <strong className={Styles.cardBreakdownValue}>{item.value}</strong>
              </span>
            ))}
          </p>
        ) : null}
      </div>
      <div className={Styles.cardBottom}>
        {description ? <p className={Styles.cardDesc}>{description}</p> : null}
        <h3 className={Styles.cardValue}>{total}</h3>
      </div>
    </div>
  );
};

export default CardItem;
